import { Logger } from "@tgtone/logger";

export const logger = new Logger({
  namespace: "licita",
  timestamp: true,
});

export default logger;
